<mini-widget-icon-card
    iconImage="assets/icons/conflict.svg"
    [color]="statusColor"
    [isLoading]="loading"
    [clickable]="true"
    (click)="goToInvoiceErrorsPage()"
>
    <div class="text-content">
        <strong>{{ 'WIDGET.MINI_INVOICE_ERRORS.TITLE' | translate }}</strong>
        <h1 class="main-content" [coloredTextColor]="statusColor">
            <span class="kpi">
                {{ invoiceErrorsTotal | localnumber: 2 : 2 }}
            </span>
            <span
                class="kpi-unit"
                [innerHTML]="'WIDGET.MINI_INVOICE_ERRORS.UNIT' | translate: { vatMode: 'STUFF.' + vatMode | translate }"
            ></span>
        </h1>
        <p class="sub-content">
            {{ 'WIDGET.MINI_INVOICE_ERRORS.INVOICE_COUNT' | translate | pluralize: invoiceErrorsCount }}
        </p>
    </div>
</mini-widget-icon-card>
